import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import WaitlistForm from '../components/WaitlistForm';

const StoryPage = () => {
  return (
    <div className="bg-[#0A0A0A] text-white min-h-screen">
      <nav className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-sm border-b border-[#2A2A2A] px-6 py-4">
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          <Link to="/" className="font-['Bebas_Neue'] text-2xl text-white" data-testid="logo-link">
            WAY BIG
          </Link>
          <div className="flex gap-6">
            <Link to="/shop" className="text-white/60 hover:text-[#FF3D00] font-['Outfit'] uppercase text-sm" data-testid="nav-shop-link">
              Shop
            </Link>
            <Link to="/" className="text-white/60 hover:text-[#FF3D00] font-['Outfit'] uppercase text-sm" data-testid="nav-home-link">
              Home
            </Link>
          </div>
        </div>
      </nav>

      <div className="pt-32 pb-24 px-6">
        <div className="max-w-4xl mx-auto space-y-24">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="min-h-[60vh] flex items-center justify-center"
          >
            <h1 data-testid="story-opening" className="font-['Bebas_Neue'] text-5xl sm:text-6xl text-center text-white uppercase leading-tight">
              We started this company because we couldn't stop eating cream biscuits.
            </h1>
          </motion.div>

          <motion.section
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="space-y-6"
          >
            <h2 className="font-['Bebas_Neue'] text-3xl sm:text-4xl text-[#FF3D00] uppercase">The Childhood</h2>
            <p className="font-['Manrope'] text-lg text-white/80 leading-relaxed">
              If you grew up in India, you know the ritual. Coming home from school. Opening the kitchen cabinet. That familiar blue packet. The satisfying twist to separate the biscuits. The cream first, or the whole thing at once? We've all been there. Oreo, Bourbon, Jim Jam—these weren't just snacks. They were moments.
            </p>
          </motion.section>

          <motion.section
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="space-y-6"
          >
            <h2 className="font-['Bebas_Neue'] text-3xl sm:text-4xl text-[#FF3D00] uppercase">The Moment</h2>
            <p className="font-['Manrope'] text-lg text-white/80 leading-relaxed">
              Then one day, I actually read the back of the pack. Refined wheat flour. Palm oil. 12 grams of sugar per serving. Hydrogenated fats. Emulsifiers I couldn't pronounce. I looked it up. Palm oil destroys rainforests. Added sugar wrecks your metabolism. And we're feeding this to kids? To ourselves? That didn't sit right.
            </p>
          </motion.section>

          <motion.section
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="space-y-6"
          >
            <h2 className="font-['Bebas_Neue'] text-3xl sm:text-4xl text-[#FF3D00] uppercase">The Gap</h2>
            <p className="font-['Manrope'] text-lg text-white/80 leading-relaxed">
              We looked for a better version. Something that tasted like childhood but didn't compromise on ingredients. It didn't exist. So we're building it. We're working on it — 10 grams of protein, 3 grams of fibre, zero palm oil, zero refined sugar. And it has to taste better than the original. If it doesn't, we won't ship it.
            </p>
          </motion.section>

          <motion.section
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="space-y-6"
          >
            <h2 className="font-['Bebas_Neue'] text-3xl sm:text-4xl text-[#FF3D00] uppercase">The Product</h2>
            <p className="font-['Manrope'] text-lg text-white/80 leading-relaxed">
              Way Big comes in four flavours: Cookies & Cream, Chocolate, Strawberry, and Tiramisu. Each 100g pack delivers 10g of protein, 3g of fibre, uses sustainable fats instead of palm oil, and gets its sweetness from natural sources—not refined sugar. It's the cream biscuit you remember, engineered for people who care about what they put in their bodies.
            </p>
          </motion.section>

          <motion.section
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="space-y-6 border-l-4 border-[#FF3D00] pl-8"
          >
            <h2 className="font-['Bebas_Neue'] text-3xl sm:text-4xl text-white uppercase">The Promise</h2>
            <p className="font-['Manrope'] text-xl text-white leading-relaxed">
              We will never use palm oil. We will never add refined sugar. We will never compromise on taste. If it doesn't taste better than the original—we don't ship it.
            </p>
          </motion.section>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="pt-12"
          >
            <div className="bg-[#FF3D00] p-12 text-center">
              <h3 className="font-['Bebas_Neue'] text-4xl text-black uppercase mb-8">Join the founding batch</h3>
              <WaitlistForm counterColor="#000000" textColor="#000000" />
            </div>
          </motion.div>
        </div>
      </div>

      <footer className="py-16 px-6 bg-black border-t border-[#2A2A2A]">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row justify-between items-center gap-8">
            <div className="font-['Bebas_Neue'] text-3xl text-white">WAY BIG</div>
            <div className="text-center text-white/50 font-['Manrope'] text-sm">
              Made in India. For people who read labels.
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default StoryPage;